import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import deviceReducer from "./device/deviceSlice";
import localeReducer from "./locale/localeSlice";
import profileSetupReducer from "./profileSetup/profileSetupSlice";
import flightSearchReducer from "./flightSearch/flightSearchSlice";
import hotelSearchReducer from "./hotelSearch/hotelSearchSlice";
import carRentalSearchReducer from "./carRentalSearch/carRentalSearchSlice";
import cruiseSearchReducer from "./cruiseSearch/cruiseSearchSlice";
import trainSearchReducer from "./trainSearch/trainSearchSlice";
import flightBookingReducer from "./flightBooking/flightBookingSlice";
import eventBookingReducer from "./eventBooking/eventBookingSlice";
import notificationsReducer from "./notifications/notificationsSlice";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from "redux-persist";

import storage from "redux-persist/lib/storage"; 

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "device", "locale", "profileSetup"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  device: deviceReducer,
  locale: localeReducer,
  profileSetup: profileSetupReducer,
  flightSearch: flightSearchReducer,
  hotelSearch: hotelSearchReducer,
  carRentalSearch: carRentalSearchReducer,
  cruiseSearch: cruiseSearchReducer,
  trainSearch: trainSearchReducer,
  flightBooking: flightBookingReducer,
  eventBooking: eventBookingReducer,
  notifications: notificationsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
        ],
      },
    }),
});

export const persistor = persistStore(store);
